import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export default function Updating(props) {
  return (
    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', height:'100%', p:0, mt:2}}>
      <CircularProgress />
      <Typography variant="button">Updating Customer Reels...</Typography>
      <Typography variant="caption">This may take a minute</Typography>
    </Box>
  );
}
